import React from 'react';
import { Button } from './ui/button';
import { ArrowRight, Download } from 'lucide-react';

const HeroSection = ({ scrollToSection }) => {
  return (
    <section className="hero-section relative min-h-screen flex items-center overflow-hidden bg-[#1a1c1b]">
      {/* Background Image with Overlay */}
      <div className="hero-background absolute inset-0">
        <img
          src="https://images.unsplash.com/photo-1585757318177-0570a997dc3a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwxfHxmb290YmFsbCUyMGNvYWNofGVufDB8fHx8MTc3NjEyOTQ0NXww&ixlib=rb-4.1.0&q=85"
          alt="Entrenador de fútbol con tablero táctico"
          className="hero-image w-full h-full object-cover"
        />
        <div className="hero-overlay absolute inset-0 bg-gradient-to-r from-[#1a1c1b] via-[#1a1c1bcc] to-transparent"></div>
      </div>

      {/* Content */}
      <div className="container mx-auto px-6 lg:px-12 relative z-10">
        <div className="max-w-3xl pt-20 lg:pt-0">
          {/* Eyebrow */}
          <div className="inline-block mb-6">
            <span className="caption text-[#d9fb06] bg-[#3f4816] px-4 py-2 rounded-full">
              PARA ENTRENADORES DE FÚTBOL NOVELES
            </span>
          </div>

          {/* Main Title */}
          <h1 className="hero-title text-[#d9fb06] mb-6">
            Tu Nombre en el Campo
          </h1>

          {/* Subtitle */}
          <p className="body-large text-white mb-8 max-w-2xl">
            Marca Personal para Entrenadores de Fútbol Noveles
          </p>

          {/* Description */}
          <p className="body-medium text-white mb-10 max-w-2xl leading-relaxed">
            Más que habilidades técnicas: construye una identidad profesional 
            sólida, una reputación impecable y una estrategia de comunicación 
            que te diferencie en el competitivo mundo del fútbol.
          </p>

          {/* CTAs */}
          <div className="flex flex-col sm:flex-row gap-4">
            <Button
              onClick={() => scrollToSection('contact')}
              className="btn-primary bg-[#d9fb06] text-[#1a1c1b] hover:bg-[#d9fb06cc] text-base lg:text-lg px-8 py-6"
            >
              <Download className="mr-2" size={20} />
              Descarga una Muestra
            </Button>
            <Button
              onClick={() => scrollToSection('sobre-libro')}
              className="btn-secondary border-[#d9fb06] text-[#d9fb06] hover:bg-[#d9fb06] hover:text-[#1a1c1b] text-base lg:text-lg px-8 py-6"
            >
              Conocer Más
              <ArrowRight className="ml-2" size={20} />
            </Button>
          </div>

          {/* Stats/Features */}
          <div className="mt-16 grid grid-cols-3 gap-6 max-w-xl">
            <div className="text-center">
              <div className="text-3xl lg:text-4xl font-bold text-[#d9fb06] mb-2">13</div>
              <div className="caption text-white">Capítulos</div>
            </div>
            <div className="text-center">
              <div className="text-3xl lg:text-4xl font-bold text-[#d9fb06] mb-2">+100</div>
              <div className="caption text-white">Ejercicios</div>
            </div>
            <div className="text-center">
              <div className="text-3xl lg:text-4xl font-bold text-[#d9fb06] mb-2">5</div>
              <div className="caption text-white">Casos Reales</div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 hidden lg:block">
        <div className="animate-bounce">
          <div className="w-6 h-10 border-2 border-[#d9fb06] rounded-full flex justify-center">
            <div className="w-1 h-3 bg-[#d9fb06] rounded-full mt-2"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
